import React from 'react';
import PropTypes from 'prop-types';
import AppRadioInput from '../../../../shared/components/app-radio-input/AppRadioInput';
import AppCheckBox from '../../../../shared/components/app-check-box/AppCheckBox';
import AppPaymentGatewaySelector from '../../../../shared/components/app-payment-gateway-selector/AppPaymentGatewaySelector';
import {
  PAYMENT_MODE_TEXT,
  WALLET_MODE,
} from '../../constants/cruiseConstants';
import { formatAmount, titleCase } from '../../utils/cruiseUtils';

function CruisePayment({
  modes,
  mode,
  onModeChange,
  pg,
  onPgChange,
  walletBalance,
  agree,
  onToggleAgree,
  showErrors,
}) {
  return (
    <div className="cr-panel cr-panel--pad">
      <b className="cr-h4">Payment</b>
      <div className="cr-options-grid">
        {modes.map((key) => {
          const m = {
            key,
            ...(PAYMENT_MODE_TEXT[key] || { label: titleCase(key), sub: '' }),
          };
          const on = mode === m.key;
          let { sub } = m;
          if (m.key === WALLET_MODE) {
            sub =
              walletBalance !== null
                ? `Available balance ${formatAmount(walletBalance)}`
                : '';
          }
          return (
            <div
              key={m.key}
              className={`cr-option cr-option--compact ${
                on ? 'is-selected' : ''
              }`}
              role="button"
              tabIndex={0}
              onClick={() => onModeChange(m.key)}
              onKeyDown={(e) => e.key === 'Enter' && onModeChange(m.key)}
            >
              <AppRadioInput
                id={`cr-pay-${m.key}`}
                name="cruisePaymentMode"
                value={m.key}
                checked={on}
                onChange={() => onModeChange(m.key)}
              />
              <div className="cr-option__main">
                <b>{m.label}</b>
                {sub && <span className="cr-muted-sm">{sub}</span>}
              </div>
            </div>
          );
        })}
      </div>

      {mode !== WALLET_MODE && (
        <div className="cr-pg">
          <AppPaymentGatewaySelector
            paymentModeClicked={mode}
            selectedPgForPaymentMode={pg}
            onPgSelect={onPgChange}
          />
        </div>
      )}

      <AppCheckBox
        id="cr-agree"
        name="cruiseAgree"
        checked={agree}
        onChange={onToggleAgree}
        labelClassName="cr-check-label cr-check-label--top"
        labelText={
          <span>
            I accept the cruise line&apos;s terms &amp; conditions{' '}
            {/* , the
            cancellation policy */}
            and confirm that all guest details are correct.
          </span>
        }
      />
      {showErrors && !agree && (
        <small className="app-error-text">
          Please accept the terms to continue
        </small>
      )}
    </div>
  );
}

CruisePayment.propTypes = {
  modes: PropTypes.arrayOf(PropTypes.string).isRequired,
  mode: PropTypes.string.isRequired,
  onModeChange: PropTypes.func.isRequired,
  pg: PropTypes.string,
  onPgChange: PropTypes.func.isRequired,
  walletBalance: PropTypes.number,
  agree: PropTypes.bool.isRequired,
  onToggleAgree: PropTypes.func.isRequired,
  showErrors: PropTypes.bool,
};

CruisePayment.defaultProps = {
  pg: '',
  walletBalance: null,
  showErrors: false,
};

export default CruisePayment;
